/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：728
 */

var r = require(/* 2491 */"./2491/index")
var i = require(/* 2494 */"./2494")
module.exports = function (e, t) {
  var n = i(e, t)
  return r(n) ? n : undefined
}
